import ConferenceBrowser from "./Browser";

export default function FavoriteEvents() {
    return <ConferenceBrowser favoriteOnly />;
}
